<template>
  <div>
    <!-- <template v-if="$store.getters.usuario.idRol == 5">
      <v-container
        class="d-flex flex-column align-center justify-center text-center"
        style="height: 100vh"
      >
        <v-card outlined class="pa-5">
          <v-card-title class="text-h5 font-weight-bold">
            ¿Desea ingresar como <span class="text-primary">Operador</span> o
            <span class="text-secondary">Contratista</span>?
          </v-card-title>
          <v-card-text>
            <v-row justify="center" align="center" class="mt-4">
              <v-btn color="primary" class="mr-4" @click="ingresarComo(2)">
                Ingresar como Operador
              </v-btn>
              <v-btn color="secondary" @click="ingresarComo(3)">
                Ingresar como Contratista
              </v-btn>
            </v-row>
          </v-card-text>
        </v-card>
      </v-container>
    </template> -->

    <v-img src="../../public/img/img-inicio.png" :aspect-ratio="16 / 9"></v-img>
  </div>
  <!-- <v-img src="../../public/img/img-inicio.png" :aspect-ratio="16 / 9"></v-img>
  <template v-if="$store.getters.usuario.idRol == 5"> -->
</template>
<script>
export default {
  mounted() {
    console.log("La variable de usuario es:");
    console.log(localStorage.usuarioActual);
    if (this.$store.getters.usuario.idRol == 4) {
      //this.obtenerUbicacionActual();
    }
  },
  methods: {
    ingresarComo(rol) {
      this.$store.commit("SET_USER_ROLE", rol);
      this.$emit("actualizar-menu", rol); // Emitir el evento
      console.log("El rol es", this.$store.getters.usuario.idRol);
      this.$router.push("/tareas");
    },

    obtenerUbicacionActual() {
      console.log("Ingreso en la ubicacion actual");
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            this.latitud = position.coords.latitude;
            this.longitud = position.coords.longitude;
            console.log("Latitud:", this.latitud);
            console.log("Longitud:", this.longitud);
          },
          (error) => {
            console.error("Error obteniendo la ubicación:", error);
            switch (error.code) {
              case error.PERMISSION_DENIED:
                alert("Permiso de geolocalización denegado.");
                break;
              case error.POSITION_UNAVAILABLE:
                alert("Información de ubicación no disponible.");
                break;
              case error.TIMEOUT:
                alert("La solicitud de ubicación ha expirado.");
                break;
              default:
                alert("Ocurrió un error desconocido.");
                break;
            }

            alert("Debe Activar la Geolocalizacion");

            this.$router.push("/");
          }
        );
      } else {
        alert("La geolocalización no es soportada por este navegador.");
      }
      //this.capturarFoto();
    },
  },
};
</script>
